import { Tile, TileContent, TileText } from '@one-thd/sui-atomic-components';
import { Settings } from '@one-thd/sui-icons';
import React from 'react';

export const PHTableSettingsTile = ({
  setEnableSettingsDrawer,
}: {
  setEnableSettingsDrawer: (enable: boolean) => void;
}) => {
  return (
    <div className="sui-flex sui-items-center sui-gap-[16px]">
      <Tile
        value="table settings"
        aria-label="table settings"
        onClick={() => setEnableSettingsDrawer(true)}
        tabIndex={0}
        onKeyDown={(event: KeyboardEvent) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setEnableSettingsDrawer(true);
          }
        }}
      >
        <TileContent>
          <span className={`sui-pt-1 `}>
            <Settings color="current" size="small" />
          </span>
          <TileText>Table Settings</TileText>
        </TileContent>
      </Tile>
    </div>
  );
};
